import FileSaver from 'file-saver'
import moment from 'moment'

import Make from './make'

const make = Make('code/')

type DownloadType = 'account' | 'user' | 'adobe'

function getDownloadAsCsvLink(type: DownloadType) {
  const token = make.getToken()
  if (!token) return ''
  if (type === 'adobe') {
    return make.getEndpoint(`download-saint-file/${token}`)
  }
  if (type === 'account') {
    return make.getEndpoint(`download-account-created-codes/${token}`)
  }
  return make.getEndpoint(`download-user-created-codes/${token}`)
}

function getDownloadTemplateLink() {
  const token = make.getToken()
  if (!token) return ''

  return make.getEndpoint(`download-bulk-template/${token}`)
}

interface NewOptions {
  optionName: string
  optionValue: string
}
export interface OptionsProps {
  // newOptions: string[]
  // parameterName: string

  fieldID: string
  fieldName: string
  newOptions: NewOptions[]
}

interface UpdateRequest {
  changeRequests: OptionsProps[]
  // reason?: string | void
  requestNote?: string | void
}

export const sendGeneratorUpdateRequest = async (
  data: UpdateRequest,
): Promise<any> => {
  const req = await make.post({
    endpoint: 'send-generator-update-request',
    data: {
      ...data,
    },
  })

  if (!req.success) {
    return false
  }

  return req?.res?.data || null
}

export interface ValidationChecks {
  enabled: boolean
  name: string
}
interface UpdateGenerator {
  masterPrefix: string
  paramSeparator: string
  validationChecks: ValidationChecks[]
}

export const updateGeneratorMasterSettings = async (
  data: UpdateGenerator,
): Promise<any> => {
  const req = await make.post({
    endpoint: 'update-generator-master-settings',
    data: {
      ...data,
    },
  })

  if (!req.success) {
    return false
  }

  return true
}

export const downloadSpecificCodes = async (data: string): Promise<any> => {
  if (typeof data === 'string') {
    const blob = new Blob([data], { type: 'text/plain;charset=utf-8' })
    const now = new Date(Date.now())
    await FileSaver.saveAs(
      blob,
      `${moment(now).format('YYYY-MM-DD')} Uplifter Campaign Codes.csv`,
    )
  }

  return true
}

export const downloadQRCode = async (
  blob: any,
  type = 'png',
  code = '',
): Promise<any> => {
  if (typeof blob !== 'undefined') {
    // const blob = new Blob([data], { type: 'image/png' })
    const now = new Date(Date.now())
    const fileName = code
      .replace(/(https:\/\/www.)|(http:\/\/)|(https:\/\/)/gi, '')
      .slice(0, 20)
    await FileSaver.saveAs(
      blob,
      `${moment(now).format('YYYY-MM-DD')} QR to ${fileName}.${type}`,
    )
  }

  return true
}

interface UploadBulkTemplate {
  file: File
}

export const uploadBulkTemplate = async (
  data: UploadBulkTemplate,
): Promise<boolean | any> => {
  const formData = new FormData()
  formData.append('uplifterBulkUpload.csv', data.file)
  formData.append('file', data.file)

  const req = await make.post({
    endpoint: 'upload-bulk-template',
    options: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  })

  if (req.success && req.res.status === 200) {
    return true
  }

  return req.res
}

interface GetCodeStats {
  // startDate: string
  // endDate: string
  metrics: string[]
}

export const getCodeStats = async (
  data: GetCodeStats,
  days: string,
): Promise<boolean | any> => {
  const req = await make.post({
    endpoint: `get-code-stats?startDate=${days}&endDate=yesterday`,
    data,
  })

  if (req.success && req.res.status === 200) {
    return req.res.data
  }

  return false
}

interface GetValidateResults {
  startDate?: string
  endDate?: string
}

export const getValidateResults = async (
  data: GetValidateResults,
): Promise<any> => {
  const req = await make.get({
    endpoint: 'get-validate-url-results',
    data: {
      ...data,
    },
  })

  if (!req.success) {
    return false
  }

  return req?.res?.data || null
}

interface ValidateUrlList {
  urlList: string[]
}

export const validateUrlList = async (data: ValidateUrlList): Promise<any> => {
  const req = await make.post({
    endpoint: 'validate-url-list',
    data: {
      ...data,
    },
  })

  if (!req.success) {
    return false
  }

  return req?.res?.data || null
}

export const getUpdateRequests = async (): Promise<any> => {
  const req = await make.get({
    endpoint: 'list-update-requests',
  })

  if (!req.success) {
    return false
  }

  return req?.res?.data || null
}

export const setUpdateRequests = async (data: any): Promise<any> => {
  const req = await make.post({
    endpoint: 'set-update-request-response',
    data,
  })

  return !!req.success
}

export const sendUpdateRequests = async (data): Promise<any> => {
  const req = await make.post({
    endpoint: 'send-update-request-response',
    data,
  })

  return !!req.success
}

export const getAccountCodesDownloadLink = () => getDownloadAsCsvLink('account')

export const getUserCodesDownloadLink = () => getDownloadAsCsvLink('user')

export const getBulkTemplateDownloadLink = () => getDownloadTemplateLink()

export const getAdobeCodesDownloadLink = () => getDownloadAsCsvLink('adobe')
